import { IS_MOBILE_APP } from '../../../constants/isMobileApp';
import { AccountWrapperSchema } from './AccountWrapperTwo.styles';

export const accountWrapperStyles: AccountWrapperSchema = {
  boxHeading: {
    bg: 'white',
    borderTopRadius: 'base',
    mb: '0',
    sx: {
      '&&': {
        pt: '2',
        pb: ['5', null, '2'],
      },
    },
  },
  boxWrapper: {
    pt: [IS_MOBILE_APP ? '2' : '0', null, 'unset'],
    mx: ['2', null, 'unset'],
  },
  textTitle: {
    mt: '0',
    mb: '2',
    color: 'alpha.700',
    fontSize: 'md',
    fontWeight: 'medium',
  },
  accountHeaderContainer: {
    sx: {
      '&&': {
        px: '0',
      },
    },
  },
  accountInfoContainer: {
    sx: {
      '&&': {
        px: '4',
        pb: '4',
        borderRadius: 'md',
        bg: 'white',
        flexDir: 'column',
        ...(IS_MOBILE_APP && {
          pt: '0',
        }),
      },
    },
  },
  titleContainer: {
    py: '1',
    ...(IS_MOBILE_APP && {
      p: '2',
      pb: '0',
    }),
  },
  flexVerticalWrapper: {
    flexDir: 'column',
    w: '100%',
  },
};
